"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterRating = void 0;
const components_1 = require("@apitable/components");
const core_1 = require("@apitable/core");
const react_1 = __importStar(require("react"));
const emoji_1 = require("../../../ui/_private/emoji");
const styled_1 = require("./styled");
const opacityMap = {
    unChecked: 0.2,
    checked: 1,
    willChecked: 0.6
};
const FilterRating = (props) => {
    const { field, value, onChange } = props;
    const [hoverIndex, setHoverIndex] = (0, react_1.useState)();
    const _value = value === null || value === void 0 ? void 0 : value[0];
    const { icon, max } = field.property;
    const handleClick = (index) => {
        if (_value === index.toString()) {
            onChange(null);
            return;
        }
        onChange([index.toString()]);
    };
    return (react_1.default.createElement(styled_1.FilterInputWrap, { onMouseOut: () => setHoverIndex(-1) }, [...Array(max !== null && max !== void 0 ? max : 1)].map((_v, i) => {
        const numValue = Number(_value);
        const iValue = i + 1;
        let opacity = 0;
        if (iValue <= numValue) {
            opacity = opacityMap.checked;
        }
        else if (hoverIndex && hoverIndex >= iValue) {
            opacity = opacityMap.willChecked;
        }
        else {
            opacity = opacityMap.unChecked;
        }
        return (react_1.default.createElement(components_1.Tooltip, { key: i, content: iValue.toString(), placement: "top" },
            react_1.default.createElement("span", { style: { opacity, cursor: 'pointer', padding: '0 2px' }, onMouseOver: () => setHoverIndex(iValue), onMouseDown: () => handleClick(iValue) },
                react_1.default.createElement(emoji_1.Emoji, { emoji: icon, size: core_1.ConfigConstant.CELL_EMOJI_SIZE }))));
    })));
};
exports.FilterRating = FilterRating;
